import Vue from "vue";
import EditShapeModal from "../../components/EditShapeModal.vue";

/**
 * Factory function to create an EditShapeModal component instance
 * @param store - Vuex store instance
 * @param coordinates - Shape coordinates
 * @param shape - Shape object with properties
 * @param vehicles - Available vehicles
 * @param map - Map instance
 * @param editable - Whether the shape is editable
 * @param addMoreShapeFunc - Function to add more shapes
 * @param renderMapFunc - Function to re-render the map
 * @param selectedFSAModeEdit - Function to enter FSA mode editing
 * @param closeEditCurrentShapeMode - Function to close edit mode
 * @returns Vue component instance
 */
export default function EditShape(
  store: any,
  coordinates: any,
  shape: any,
  vehicles: any,
  map: any,
  editable: boolean,
  addMoreShapeFunc: (a: boolean) => {},
  renderMapFunc: (gettingZone: boolean, region: string) => {},
  selectedFSAModeEdit: () => {},
  closeEditCurrentShapeMode: () => {}
) {
  const ComponentClass = Vue.extend(EditShapeModal);
  const instance = new ComponentClass({
    propsData: {
      store,
      coordinates,
      shape,
      vehicles,
      editable,
      // Pass the distributionZones from the store to the component
      distributionZones: store.state.hubs,
    },
    methods: {
      close: () => {
        closeEditCurrentShapeMode();
        map.closePopup();
      },
      addMoreShapeFunc: (toAdd: boolean) => {
        addMoreShapeFunc(toAdd);
      },
      renderMapFunc: async () => {
        setTimeout(async () => {
          await renderMapFunc(true, store.state.region);
        }, 1000);
      },
      selectedFSAModeEdit: async () => {
        await selectedFSAModeEdit();
      },
      /**
       * Finds a distribution hub by ID
       * @param distributionZoneId - ID of the distribution hub
       * @returns The distribution hub object or null
       */
      findDistributionZoneById: (distributionZoneId: string) => {
        if (!distributionZoneId) return null;
        return store.state.hubs.find(
          (hub: any) => hub.DistributionZoneId === distributionZoneId
        );
      },
      /**
       * Filters the hubs by the current region
       * @returns Array of hubs filtered by the current region
       */
      getFilteredHubs: () => {
        const currentRegion = store.state.region;
        if (!currentRegion) {
          return store.state.hubs;
        }
        return store.state.hubs.filter(
          (hub: any) => hub.Region === currentRegion
        );
      },
    },
  });

  return instance;
}
